import { Map } from 'leaflet';
import { GestureHandling } from 'leaflet-gesture-handling';

// Import css for gesture handline
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

// Import css for the marker cluster groups
import 'react-leaflet-markercluster/dist/styles.min.css';

// Add gesture handling plugin
Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
